import React from "react";
import { ArrowRight } from "lucide-react";
import { money, num } from "@/lib/sk";

const K = (v) => money(v, "NOK", 1, { bare: true });

/**
 * The living economy line while you work: one opaque 56 px line that follows the list column – Fastprissum · Kost · DB,
 * what is still left, and the way on to the quote. Without a sum it says so honestly instead of showing a zero.
 */
export function Totals({ totals, status, missing, onQuote }) {
  const t = totals || {};
  const hasSum = Boolean(status?.hasSum);
  const complete = t.sum_kind === "complete";
  const cell = (label, v, strong) => <div className="flex items-baseline gap-1.5"><span className="k-meta">{label}</span><span className={strong ? "k-amount text-[16px] text-foreground" : "k-amount text-foreground/85"}>{v}</span></div>;
  return (
    <div className="sticky bottom-0 z-10 h-14 border-t border-black/[0.08] bg-white px-5 shadow-[0_-6px_16px_-12px_hsl(var(--shadow-color)/0.25)]" data-testid="kalkyle-totals" data-sum-kind={t.sum_kind} data-has-sum={hasSum ? "1" : "0"}>
      <div className="flex h-full flex-wrap items-center gap-x-7 gap-y-1">
        {hasSum ? (
          <>
            {cell("Fastprissum", `${K(t.price)} kr${t.sum_kind === "preliminary" ? " · foreløpig" : ""}`, true)}
            {cell("Kost", `${K(t.cost)} kr`)}
            {cell("DB", t.price ? `${K(t.price - t.cost)} kr · ${num(t.db_pct, 1)} %` : "–")}
          </>
        ) : (
          <div className="flex items-baseline gap-1.5"><span className="k-meta">Fastprissum</span><span className="k-amount text-[16px] text-muted-foreground/60">–</span><span className="k-meta">ingen poster i fastpris er priset ennå</span></div>
        )}
        <div className="ml-auto flex items-center gap-4 text-[13px] text-muted-foreground">
          {missing ? <span className="font-medium text-[hsl(var(--v-assumed))]" data-testid="kalkyle-missing">{missing} {missing === 1 ? "post gjenstår" : "poster gjenstår"}</span> : null}
          {complete && !missing ? <button type="button" onClick={onQuote} className="inline-flex h-8 items-center gap-1 rounded-full px-2.5 text-[13.5px] font-medium text-[hsl(var(--brand-strong))] transition-colors hover:bg-[hsl(var(--brand-soft))]" data-testid="kalkyle-to-tilbud">Vis tilbud <ArrowRight className="h-3.5 w-3.5" /></button> : null}
        </div>
      </div>
    </div>
  );
}
